import { SelectOption } from "../../../../packages/ui/form/select/SelectOption.js";

export const currencyOptions: SelectOption[] = [
  { value: "eur", label: "EUR" },
  { value: "usd", label: "USD" },
  { value: "gbp", label: "GBP" }
];
